// popup-options.js
// ITS ALSO LINK IN PRODUCT-INFO PAGE

document.addEventListener('DOMContentLoaded', function () {
  // --- 1. CONFIGURATION ---
  const MAX_BOTTLE_SELECTIONS = 1;
  const MAX_CARD_SELECTIONS = 3;

  const addToCartButtonSelector = 'button[name="add"]';
  const buyNowButtonSelector = '[data-shopify="payment-button"] button';

  const fragranceBottleMap = {
    'Ivaa-Xperia-popup': [
      { name: 'CHRISTMAS IN A BOTTLE', image: 'https://cdn.shopify.com/s/files/1/0725/5680/6394/files/CHRISTMAS_IN_A_BOTTLE.webp?v=1765096887' },
      { name: 'GOOEY CHOCOLATE BROWNIE', image: 'https://cdn.shopify.com/s/files/1/0725/5680/6394/files/GOOEY_CHOCOLATE_BROWNIE.webp?v=1765099044' },
      { name: 'VANILLA COOKIE CRUMBLE', image: 'https://cdn.shopify.com/s/files/1/0725/5680/6394/files/VANILLA_COOKIE_CRUMBLE.webp?v=1765099043' },
      { name: 'DUBAI CHOCOLATE', image: 'https://cdn.shopify.com/s/files/1/0725/5680/6394/files/DUBAI_CHOCOLATE.webp?v=1765099043' },
      { name: 'BLACKCURRANT MAGIC', image: 'https://cdn.shopify.com/s/files/1/0725/5680/6394/files/BLACKCURRANT_MAGIC.webp?v=1765099045' },
      { name: 'BERRY BLAST', image: 'https://cdn.shopify.com/s/files/1/0725/5680/6394/files/BERRY_BLAST.webp?v=1765099043' },
      { name: 'TIRA MISS YOU', image: 'https://cdn.shopify.com/s/files/1/0725/5680/6394/files/TIRA_MISS_YOU.webp?v=1765099043', comingSoon: true },
      { name: 'LOBAN AURA', image: 'https://cdn.shopify.com/s/files/1/0725/5680/6394/files/LOBAN_AURA.webp?v=1755243786', soldOut: true },
      { name: 'JASMINE', image: 'https://cdn.shopify.com/s/files/1/0725/5680/6394/files/JASMINE.webp?v=1755243786' },
      { name: 'KASHMIRI NARGIS', image: 'https://cdn.shopify.com/s/files/1/0725/5680/6394/files/KASHMIRI_NARGIS.webp?v=1755243786' },
      { name: 'SANDALWOOD', image: 'https://cdn.shopify.com/s/files/1/0725/5680/6394/files/SANDALWOOD.webp?v=1755243786' },
      { name: 'WHITE FLORAL', image: 'https://cdn.shopify.com/s/files/1/0725/5680/6394/files/WHITE_FLORAL.webp?v=1755243786' },
      { name: 'AQUA BROOKE', image: 'https://cdn.shopify.com/s/files/1/0725/5680/6394/files/AQUA_BROOKE.webp?v=1730265649' },
      { name: 'INTENSE OUDH', image: 'https://cdn.shopify.com/s/files/1/0725/5680/6394/files/INTENSE_OUDH.webp?v=1730265648' },
      { name: 'SPICY VETIVER', image: 'https://cdn.shopify.com/s/files/1/0725/5680/6394/files/SPICY_VETIVER.webp?v=1730265648', soldOut:true },
      { name: 'SUMMER SPLASH', image: 'https://cdn.shopify.com/s/files/1/0725/5680/6394/files/SUMMER_SPLASH.webp?v=1730265649' },
      { name: 'FOREST TRAIL', image: 'https://cdn.shopify.com/s/files/1/0725/5680/6394/files/FOREST_TRAIL.webp?v=1730265649', soldOut: true },
      { name: 'FROSTY ZENITH', image: 'https://cdn.shopify.com/s/files/1/0725/5680/6394/files/FROSTY_ZENITH.webp?v=1730265648', soldOut: true  },
      { name: 'OUDH SAFFRON', image: 'https://cdn.shopify.com/s/files/1/0725/5680/6394/files/OUDH_SAFFRON.webp?v=1730265648' },
      { name: 'WOODY PATCHOULI', image: 'https://cdn.shopify.com/s/files/1/0725/5680/6394/files/Woddy-Patchouli.webp?v=1729615881' },
      { name: 'TROPICAL SUNRISE', image: 'https://cdn.shopify.com/s/files/1/0725/5680/6394/files/TROPICAL_SUNRISE.webp?v=1730265649'},
      { name: 'AMBER WOOD', image: 'https://cdn.shopify.com/s/files/1/0725/5680/6394/files/REDWOOD_SYMPHONY.webp?v=1730265648',}
    ],
    'popup-electronics-options': [
      { name: 'Extended Warranty', image: 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-warranty_large.png' },
      { name: 'Setup Service', image: 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-setup_large.png' },
      { name: 'Accidental Damage Cover', image: 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-protection_large.png' }
    ],
    'popup-apparel-options': [
      { name: 'Monogramming', image: 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-monogram_large.png' },
      { name: 'Gift Box', image: 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-gift-box_large.png' },
      { name: 'Alteration Voucher', image: 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-alteration_large.png' }
    ]
  };

  const fragranceCardMap = {
    'Scentcup-popup': [
      { name: 'Rise & Shine', image: 'https://cdn.shopify.com/s/files/1/0725/5680/6394/files/Rise_And_Shine_f0eb2344-8324-4714-8048-3f23a37f2841.jpg?v=1764852361' },
      { name: 'After Dusk', image: 'https://cdn.shopify.com/s/files/1/0725/5680/6394/files/After_Dusk_6d3ee70f-2aaa-4fe2-bdd4-25f7f65a682c.jpg?v=1764852360' },
      { name: 'Brew Bliss', image: 'https://cdn.shopify.com/s/files/1/0725/5680/6394/files/Coffee_Brew_1eeef962-222f-46b9-8416-4604ae5483af.jpg?v=1764852360' },
      { name: 'Night Fusion', image: 'https://cdn.shopify.com/s/files/1/0725/5680/6394/files/Night_Fusion_be892f39-5848-4c93-9572-06dffd5ac6cd.jpg?v=1764852361' },
      { name: 'Timber Trails', image: 'https://cdn.shopify.com/s/files/1/0725/5680/6394/files/Timber_Trails_6f6f8f19-355d-47b9-ad69-26240296195d.jpg?v=1764852361' }
    ]
  };

  // --- 2. GET ELEMENTS & DATA ---
  const customizeBottleBtn = document.getElementById('customize-options-btn');
  const customizeCardBtn = document.getElementById('customize-card-btn');

  if (!customizeBottleBtn && !customizeCardBtn) return;

  const bottleModal = document.getElementById('options-modal');
  const cardModal = document.getElementById('card-modal');
  const closeBtns = document.querySelectorAll('.close-btn');
  const bottleContainer = document.getElementById('options-container');
  const cardContainer = document.getElementById('card-container');
  const addToCartButton = document.querySelector(addToCartButtonSelector);
  const buyNowButton = document.querySelector(buyNowButtonSelector);
  const bottleSelectionMessage = document.getElementById('bottle-selection-message');
  const cardSelectionMessage = document.getElementById('card-selection-message');
  const bottlePopupHeading = document.getElementById('bottle-popup-heading');
  const cardPopupHeading = document.getElementById('card-popup-heading');
  const propertiesContainer = document.getElementById('custom-properties-container');
  const productForm = document.querySelector('form[action="/cart/add"]');
  const productTags = window.productTags || [];

  // --- 3. DETERMINE OPTIONS FOR THIS PRODUCT ---
  let bottleOptions = [];
  let cardOptions = [];
  let hasBottlePopup = false;
  let hasCardPopup = false;

  for (const tag of productTags) {
    if (fragranceBottleMap[tag]) {
      bottleOptions = fragranceBottleMap[tag];
      hasBottlePopup = true;
    }
    if (fragranceCardMap[tag]) {
      cardOptions = fragranceCardMap[tag];
      hasCardPopup = true;
    }
  }

  // Hide irrelevant buttons and modals
  if (!hasBottlePopup) {
    if (customizeBottleBtn) customizeBottleBtn.style.display = 'none';
    if (bottleModal) bottleModal.style.display = 'none';
    if (bottlePopupHeading) bottlePopupHeading.style.display = 'none';
  }

  if (!hasCardPopup) {
    if (customizeCardBtn) customizeCardBtn.style.display = 'none';
    if (cardModal) cardModal.style.display = 'none';
    if (cardPopupHeading) cardPopupHeading.style.display = 'none';
  }

  // FIX 1: Hard exit if this product has no popup at all (e.g. Aerosonic)
  // Stops ATC listener attaching and blocking checkout on unrelated products
  if (!hasBottlePopup && !hasCardPopup) return;

  // --- 4. STATE MANAGEMENT ---
  let selectedBottleCounts = {};
  let selectedCardCounts = {};

  function getTotalSelections(countObj) {
    return Object.values(countObj).reduce((sum, count) => sum + count, 0);
  }

  function getExpandedSelections(countObj) {
    const expanded = [];
    Object.keys(countObj).forEach((name) => {
      const count = countObj[name] || 0;
      for (let i = 0; i < count; i++) {
        expanded.push(name);
      }
    });
    return expanded;
  }

  function updateBottleSelectionMessage() {
    if (!bottleSelectionMessage) return;
    const totalBottleSelections = getTotalSelections(selectedBottleCounts);
    if (totalBottleSelections === MAX_BOTTLE_SELECTIONS) {
      bottleSelectionMessage.textContent = `Perfect! You have selected ${MAX_BOTTLE_SELECTIONS} fragrance.`;
      bottleSelectionMessage.style.color = 'green';
    } else {
      bottleSelectionMessage.textContent = `Please select ${MAX_BOTTLE_SELECTIONS} fragrance. You have selected ${totalBottleSelections}.`;
      bottleSelectionMessage.style.color = 'red';
    }
  }

  function updateCardSelectionMessage() {
    if (!cardSelectionMessage) return;
    const totalCardSelections = getTotalSelections(selectedCardCounts);
    if (totalCardSelections === MAX_CARD_SELECTIONS) {
      cardSelectionMessage.textContent = `Perfect! You have selected ${MAX_CARD_SELECTIONS} fragrances.`;
      cardSelectionMessage.style.color = 'green';
    } else {
      cardSelectionMessage.textContent = `Please select ${MAX_CARD_SELECTIONS} fragrances. You have selected ${totalCardSelections}.`;
      cardSelectionMessage.style.color = 'red';
    }
  }

  function validateSelections() {
    const totalBottleSelections = getTotalSelections(selectedBottleCounts);
    const totalCardSelections = getTotalSelections(selectedCardCounts);

    let isBottleValid = true;
    let isCardValid = true;

    if (hasBottlePopup && totalBottleSelections !== MAX_BOTTLE_SELECTIONS) {
      isBottleValid = false;
    }
    if (hasCardPopup && totalCardSelections !== MAX_CARD_SELECTIONS) {
      isCardValid = false;
    }

    return { isBottleValid, isCardValid };
  }

  function lockBodyScroll() {
    document.body.classList.add('modal-open');
  }

  function unlockBodyScroll() {
    document.body.classList.remove('modal-open');
  }

  // --- IMAGE PREVIEW FUNCTIONALITY ---
  function createImagePreviewModal() {
    if (document.getElementById('image-preview-modal')) return;

    const modal = document.createElement('div');
    modal.id = 'image-preview-modal';
    modal.className = 'image-preview-modal';
    modal.style.display = 'none';

    const closeBtn = document.createElement('span');
    closeBtn.className = 'image-preview-close';
    closeBtn.innerHTML = '&times;';
    closeBtn.onclick = closeImagePreview;

    const img = document.createElement('img');
    img.id = 'preview-image';
    img.className = 'preview-image-content';

    modal.appendChild(closeBtn);
    modal.appendChild(img);
    document.body.appendChild(modal);

    modal.onclick = function (event) {
      if (event.target === modal) {
        closeImagePreview();
      }
    };
  }

  function showImagePreview(imageSrc) {
    const modal = document.getElementById('image-preview-modal');
    const img = document.getElementById('preview-image');
    if (modal && img) {
      img.src = imageSrc;
      modal.style.display = 'flex';
      lockBodyScroll();
    }
  }

  function closeImagePreview() {
    const modal = document.getElementById('image-preview-modal');
    if (modal) {
      modal.style.display = 'none';
      unlockBodyScroll();
    }
  }

  // --- COMMON UI HELPERS ---
  function createQuantityControl(type, optionName, maxSelections) {
    const wrapper = document.createElement('div');
    wrapper.className = 'quantity-selector';
    wrapper.style.display = 'none';
    wrapper.style.alignItems = 'center';
    wrapper.style.gap = '8px';

    const minusBtn = document.createElement('button');
    minusBtn.type = 'button';
    minusBtn.className = 'qty-btn qty-minus';
    minusBtn.textContent = '-';

    const countSpan = document.createElement('span');
    countSpan.className = 'qty-count';
    countSpan.textContent = '1';
    countSpan.style.minWidth = '20px';
    countSpan.style.textAlign = 'center';

    const plusBtn = document.createElement('button');
    plusBtn.type = 'button';
    plusBtn.className = 'qty-btn qty-plus';
    plusBtn.textContent = '+';

    minusBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (type === 'bottle') {
        let currentCount = selectedBottleCounts[optionName] || 0;
        if (currentCount <= 0) return;
        currentCount -= 1;
        if (currentCount <= 0) {
          delete selectedBottleCounts[optionName];
        } else {
          selectedBottleCounts[optionName] = currentCount;
        }
        refreshOptionUI(type, optionName, maxSelections);
        updateBottleSelectionMessage();
      } else {
        let currentCount = selectedCardCounts[optionName] || 0;
        if (currentCount <= 0) return;
        currentCount -= 1;
        if (currentCount <= 0) {
          delete selectedCardCounts[optionName];
        } else {
          selectedCardCounts[optionName] = currentCount;
        }
        refreshOptionUI(type, optionName, maxSelections);
        updateCardSelectionMessage();
      }
    });

    plusBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (type === 'bottle') {
        const totalBottleSelections = getTotalSelections(selectedBottleCounts);
        if (totalBottleSelections >= maxSelections) return;
        selectedBottleCounts[optionName] = (selectedBottleCounts[optionName] || 0) + 1;
        refreshOptionUI(type, optionName, maxSelections);
        updateBottleSelectionMessage();
      } else {
        const totalCardSelections = getTotalSelections(selectedCardCounts);
        if (totalCardSelections >= maxSelections) return;
        selectedCardCounts[optionName] = (selectedCardCounts[optionName] || 0) + 1;
        refreshOptionUI(type, optionName, maxSelections);
        updateCardSelectionMessage();
      }
    });

    wrapper.appendChild(minusBtn);
    wrapper.appendChild(countSpan);
    wrapper.appendChild(plusBtn);

    return wrapper;
  }

  function refreshOptionUI(type, optionName, maxSelections) {
    const selector =
      type === 'bottle'
        ? `.option-item[data-option-name="${CSS.escape(optionName)}"]`
        : `.fragrance-card[data-option-name="${CSS.escape(optionName)}"]`;

    const item = document.querySelector(selector);
    if (!item) return;

    const selectBtn = item.querySelector('.select-btn');
    const qtyWrapper = item.querySelector('.quantity-selector');
    const qtyCount = item.querySelector('.qty-count');

    const count =
      type === 'bottle'
        ? (selectedBottleCounts[optionName] || 0)
        : (selectedCardCounts[optionName] || 0);

    const totalSelections =
      type === 'bottle'
        ? getTotalSelections(selectedBottleCounts)
        : getTotalSelections(selectedCardCounts);

    if (maxSelections === 1) {
      if (count > 0) {
        item.classList.add('selected');
        if (selectBtn) {
          selectBtn.textContent = 'Unselect';
          selectBtn.classList.add('unselect');
        }
      } else {
        item.classList.remove('selected');
        if (selectBtn) {
          selectBtn.textContent = 'Select';
          selectBtn.classList.remove('unselect');
        }
      }
      return;
    }

    if (count > 0) {
      item.classList.add('selected');
      if (selectBtn) selectBtn.style.display = 'none';
      if (qtyWrapper) qtyWrapper.style.display = 'flex';
      if (qtyCount) qtyCount.textContent = String(count);
    } else {
      item.classList.remove('selected');
      if (selectBtn) selectBtn.style.display = 'inline-flex';
      if (qtyWrapper) qtyWrapper.style.display = 'none';
      if (qtyCount) qtyCount.textContent = '1';
    }

    const allItems = type === 'bottle'
      ? document.querySelectorAll('.option-item')
      : document.querySelectorAll('.fragrance-card');

    allItems.forEach((el) => {
      const name = el.dataset.optionName;
      const plusBtn = el.querySelector('.qty-plus');
      const selectButton = el.querySelector('.select-btn');
      const currentOptionCount =
        type === 'bottle'
          ? (selectedBottleCounts[name] || 0)
          : (selectedCardCounts[name] || 0);

      const canAddMore = totalSelections < maxSelections;

      if (plusBtn) {
        plusBtn.disabled = !canAddMore;
        if (currentOptionCount > 0 && !canAddMore) {
          plusBtn.disabled = true;
        }
      }

      if (selectButton && !el.querySelector('.quantity-selector')) return;

      if (maxSelections > 1 && selectButton && currentOptionCount === 0) {
        selectButton.disabled = !canAddMore;
        selectButton.style.opacity = canAddMore ? '1' : '0.5';
        selectButton.style.cursor = canAddMore ? 'pointer' : 'not-allowed';
      }
    });
  }

  // FIX 4: Generic "unavailable" handling covers both Coming Soon and Sold Out
  // states. Each option can set `comingSoon: true` OR `soldOut: true` (not
  // both) to render an overlay + disabled button with the matching label.
  function getUnavailableLabel(option) {
    if (option.comingSoon === true) return 'Coming Soon';
    if (option.soldOut === true) return 'Sold Out';
    return null;
  }

  function buildOptionCard(option, type, maxSelections) {
    const unavailableLabel = getUnavailableLabel(option);
    const isUnavailable = unavailableLabel !== null;
    const isMultiQuantity = maxSelections > 1;

    const item = document.createElement('div');
    item.className = type === 'bottle' ? 'option-item' : 'fragrance-card';
    item.dataset.optionName = option.name;

    if (option.soldOut === true) item.classList.add('sold-out');
    if (option.comingSoon === true) item.classList.add('coming-soon');

    const contentDiv = document.createElement('div');
    contentDiv.className = 'option-content';

    const checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.value = option.name;
    checkbox.style.display = 'none';
    if (isUnavailable) checkbox.disabled = true;

    const imageContainer = document.createElement('div');
    imageContainer.className = 'option-image-container';
    imageContainer.style.position = 'relative';

    const img = document.createElement('img');
    img.src = option.image;
    img.alt = option.name;
    img.loading = 'lazy';
    img.style.width = '100%';
    img.style.display = 'block';

    if (isUnavailable) {
      const overlay = document.createElement('div');
      overlay.className = option.soldOut === true ? 'sold-out-overlay' : 'coming-soon-overlay';
      overlay.style.position = 'absolute';
      overlay.style.top = '0';
      overlay.style.left = '0';
      overlay.style.width = '100%';
      overlay.style.height = '100%';
      overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
      overlay.style.display = 'flex';
      overlay.style.justifyContent = 'center';
      overlay.style.alignItems = 'center';
      overlay.style.color = 'white';
      overlay.style.fontSize = '1.2rem';
      overlay.style.fontWeight = 'bold';
      overlay.textContent = unavailableLabel;
      imageContainer.appendChild(overlay);
    }

    imageContainer.appendChild(img);

    const textContainer = document.createElement('div');
    textContainer.className = 'option-text-container';

    const nameSpan = document.createElement('span');
    nameSpan.className = 'option-name';
    nameSpan.textContent = option.name;

    const buttonContainer = document.createElement('div');
    buttonContainer.className = 'option-button-container';

    const previewBtn = document.createElement('button');
    previewBtn.className = 'preview-btn';
    previewBtn.textContent = 'Preview';
    previewBtn.type = 'button';
    previewBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      showImagePreview(option.image);
    });

    const selectBtn = document.createElement('button');
    selectBtn.className = 'select-btn';
    selectBtn.type = 'button';

    if (isUnavailable) {
      selectBtn.textContent = unavailableLabel;
      selectBtn.disabled = true;
      selectBtn.style.opacity = '0.5';
      selectBtn.style.cursor = 'not-allowed';
    } else {
      selectBtn.textContent = 'Select';

      selectBtn.addEventListener('click', function (e) {
        e.stopPropagation();

        if (type === 'bottle') {
          if (maxSelections === 1) {
            const currentCount = selectedBottleCounts[option.name] || 0;
            if (currentCount > 0) {
              selectedBottleCounts = {};
              checkbox.checked = false;
            } else {
              selectedBottleCounts = {};
              selectedBottleCounts[option.name] = 1;
              document.querySelectorAll('.option-item').forEach((el) => {
                const name = el.dataset.optionName;
                const input = el.querySelector('input[type="checkbox"]');
                if (input) input.checked = name === option.name;
                refreshOptionUI('bottle', name, maxSelections);
              });
              updateBottleSelectionMessage();
              return;
            }
            checkbox.checked = !!selectedBottleCounts[option.name];
            refreshOptionUI('bottle', option.name, maxSelections);
            updateBottleSelectionMessage();
            return;
          }

          const totalBottleSelections = getTotalSelections(selectedBottleCounts);
          if (totalBottleSelections >= maxSelections) return;
          selectedBottleCounts[option.name] = (selectedBottleCounts[option.name] || 0) + 1;
          checkbox.checked = true;
          refreshOptionUI('bottle', option.name, maxSelections);
          updateBottleSelectionMessage();
        } else {
          if (maxSelections === 1) {
            const currentCount = selectedCardCounts[option.name] || 0;
            if (currentCount > 0) {
              selectedCardCounts = {};
              checkbox.checked = false;
            } else {
              selectedCardCounts = {};
              selectedCardCounts[option.name] = 1;
              document.querySelectorAll('.fragrance-card').forEach((el) => {
                const name = el.dataset.optionName;
                const input = el.querySelector('input[type="checkbox"]');
                if (input) input.checked = name === option.name;
                refreshOptionUI('card', name, maxSelections);
              });
              updateCardSelectionMessage();
              return;
            }
            checkbox.checked = !!selectedCardCounts[option.name];
            refreshOptionUI('card', option.name, maxSelections);
            updateCardSelectionMessage();
            return;
          }

          const totalCardSelections = getTotalSelections(selectedCardCounts);
          if (totalCardSelections >= maxSelections) return;
          selectedCardCounts[option.name] = (selectedCardCounts[option.name] || 0) + 1;
          checkbox.checked = true;
          refreshOptionUI('card', option.name, maxSelections);
          updateCardSelectionMessage();
        }
      });
    }

    buttonContainer.appendChild(previewBtn);
    buttonContainer.appendChild(selectBtn);

    if (!isUnavailable && isMultiQuantity) {
      const quantityControl = createQuantityControl(type, option.name, maxSelections);
      buttonContainer.appendChild(quantityControl);
    }

    textContainer.appendChild(nameSpan);
    textContainer.appendChild(buttonContainer);

    contentDiv.appendChild(imageContainer);
    contentDiv.appendChild(textContainer);

    item.appendChild(contentDiv);
    item.appendChild(checkbox);

    return item;
  }

  // --- 5. POPULATE THE BOTTLE POPUP ---
  function populateBottlePopup() {
    if (!bottleContainer) return;
    bottleContainer.innerHTML = '';

    if (bottleOptions.length === 0) {
      if (customizeBottleBtn) customizeBottleBtn.style.display = 'none';
      if (bottlePopupHeading) bottlePopupHeading.style.display = 'none';
      return;
    }

    if (bottlePopupHeading) bottlePopupHeading.style.display = 'block';

    bottleOptions.forEach((option) => {
      const optionCard = buildOptionCard(option, 'bottle', MAX_BOTTLE_SELECTIONS);
      bottleContainer.appendChild(optionCard);
    });
  }

  // --- 5b. POPULATE THE CARD POPUP ---
  function populateCardPopup() {
    if (!cardContainer) return;
    cardContainer.innerHTML = '';

    if (cardOptions.length === 0) {
      if (customizeCardBtn) customizeCardBtn.style.display = 'none';
      if (cardPopupHeading) cardPopupHeading.style.display = 'none';
      return;
    }

    if (cardPopupHeading) cardPopupHeading.style.display = 'block';

    cardOptions.forEach((option) => {
      const card = buildOptionCard(option, 'card', MAX_CARD_SELECTIONS);
      cardContainer.appendChild(card);
    });
  }

  // --- 6. CORE LOGIC: INTERCEPT BUTTON CLICK AND ADD PROPERTIES ---
  if (addToCartButton && propertiesContainer) {
    addToCartButton.addEventListener('click', function (event) {
      const { isBottleValid, isCardValid } = validateSelections();
      const totalBottleSelections = getTotalSelections(selectedBottleCounts);
      const totalCardSelections = getTotalSelections(selectedCardCounts);

      if (!isBottleValid || !isCardValid) {
        event.preventDefault();

        // FIX 2: Inline error messages instead of alert()
        if (!isBottleValid && bottleSelectionMessage) {
          updateBottleSelectionMessage();
        }
        if (!isCardValid && cardSelectionMessage) {
          updateCardSelectionMessage();
        }

        if (!isBottleValid && hasBottlePopup && bottleModal) {
          bottleModal.style.display = 'block';
          lockBodyScroll();
          updateBottleSelectionMessage();
        }

        if (!isCardValid && hasCardPopup && cardModal) {
          cardModal.style.display = 'block';
          lockBodyScroll();
          updateCardSelectionMessage();
        }
      } else {
        propertiesContainer.innerHTML = '';

        const expandedBottleSelections = getExpandedSelections(selectedBottleCounts);
        const expandedCardSelections = getExpandedSelections(selectedCardCounts);

        expandedBottleSelections.forEach((optionName, index) => {
          const hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.name = `properties[Fragrance ${index + 1}]`;
          hiddenInput.value = optionName;
          propertiesContainer.appendChild(hiddenInput);
        });

        expandedCardSelections.forEach((cardName, index) => {
          const hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.name = `properties[Fragrance Card ${index + 1}]`;
          hiddenInput.value = cardName;
          propertiesContainer.appendChild(hiddenInput);
        });

        unlockBodyScroll();
      }
    });
  }

  // --- 6b. BUY NOW / MINI-CART SYNC LOGIC ---
  if (buyNowButton && productForm) {
    buyNowButton.addEventListener(
      'click',
      function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        const { isBottleValid, isCardValid } = validateSelections();

        if (!isBottleValid || !isCardValid) {
          if (!isBottleValid && hasBottlePopup && bottleModal) {
            bottleModal.style.display = 'block';
            updateBottleSelectionMessage();
          } else if (!isCardValid && hasCardPopup && cardModal) {
            cardModal.style.display = 'block';
            updateCardSelectionMessage();
          }
          lockBodyScroll();
          return;
        }

        const variantId = productForm.querySelector('[name="id"]').value;
        const qty = productForm.querySelector('[name="quantity"]')?.value || 1;

        let properties = {};
        const expandedBottleSelections = getExpandedSelections(selectedBottleCounts);
        const expandedCardSelections = getExpandedSelections(selectedCardCounts);

        expandedBottleSelections.forEach((name, i) => {
          properties[`Fragrance ${i + 1}`] = name;
        });

        expandedCardSelections.forEach((name, i) => {
          properties[`Fragrance Card ${i + 1}`] = name;
        });

        const formData = {
          items: [{ id: variantId, quantity: qty, properties: properties }]
        };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData)
        })
          .then(() => {
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', { bubbles: true })
            );
            window.location.href = '/checkout';
          })
          .catch((error) => {
            console.error('Error:', error);
            window.location.href = '/checkout';
          });
      },
      true
    );
  }

  // --- 7. EVENT LISTENERS ---
  closeBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const modal = btn.closest('.modal');
      if (modal) {
        modal.style.display = 'none';
        unlockBodyScroll();
      }
    });
  });

  if (customizeBottleBtn) {
    customizeBottleBtn.addEventListener('click', () => {
      if (bottleModal) {
        bottleModal.style.display = 'block';
        lockBodyScroll();
      }
    });
  }

  if (customizeCardBtn) {
    customizeCardBtn.addEventListener('click', () => {
      if (cardModal) {
        cardModal.style.display = 'block';
        lockBodyScroll();
      }
    });
  }

  window.addEventListener('click', (event) => {
    if (event.target === bottleModal) {
      bottleModal.style.display = 'none';
      unlockBodyScroll();
    }
    if (event.target === cardModal) {
      cardModal.style.display = 'none';
      unlockBodyScroll();
    }
  });

  // FIX 3: ESC key closes modals and unlocks scroll safely
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (bottleModal) bottleModal.style.display = 'none';
      if (cardModal) cardModal.style.display = 'none';
      unlockBodyScroll();
    }
  });

  // FIX 3: Safety unlock if user tabs away with modal open
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      unlockBodyScroll();
    }
  });

  // --- 8. INITIALIZE ---
  createImagePreviewModal();
  populateBottlePopup();
  populateCardPopup();

  if (hasBottlePopup) updateBottleSelectionMessage();
  if (hasCardPopup) updateCardSelectionMessage();

  if (hasBottlePopup) {
    bottleOptions.forEach((option) => refreshOptionUI('bottle', option.name, MAX_BOTTLE_SELECTIONS));
  }
  if (hasCardPopup) {
    cardOptions.forEach((option) => refreshOptionUI('card', option.name, MAX_CARD_SELECTIONS));
  }
});